const f = {
  color: {
    border: {
      default: "#c8d3deff",
      hover: "#abb9c7ff",
      checked: "#9ecbffff",
      locked: "#d7baf5ff"
    },
    bg: {
      default: "#ffffffff",
      hover: "#f9fafaff",
      checked: "#ebf5ffff",
      locked: "#f9f2ffff",
      disabled: "#f9fafaff"
    },
    mark: {
      default: "#304ddbff",
      locked: {
        default: "#9163bfff",
        disabled: "#d7baf5ff"
      }
    },
    text: {
      default: "#556575ff",
      checked: "#405261ff",
      disabled: "#7e8e9eff"
    },
    heading: {
      default: "#314351ff"
    }
  }
};
export {
  f as optionCard
};
